(function() {

    angular.module("noticesModule").controller("NoticesController", NoticesController)

    NoticesController.$inject = [
        "$rootScope",
        "$scope",
        "$sce",
        "$uibModal",
        "noticeService"
    ]

    function NoticesController(
        $rootScope,
        $scope,
        $sce,
        $uibModal,
        noticeService
    ){

        "use strict"

        $rootScope.title = "Notices | WANCO"

        $scope.notices            = []
        $scope.noticesForDisplay  = []
        $scope.showType           = "Unread"
        $scope.searchText         = ""
        $scope.allowToggleContent = true
        $scope.retrievingNotices  = true

        const getNotices = (manage, searchText) => {

            noticeService.getNotices(manage, searchText, (data) => {

                $scope.notices = data

                if (searchText !== undefined && searchText !== "") {
                    $scope.showType = "Search"
                } else if (manage) {
                    $scope.showType = "Manage"
                } else {
                    $scope.showType = "Unread"
                }

                $scope.retrievingNotices = false
                updateDisplayed()

            })
        }

        getNotices()

        const updateDisplayed = function() {

            $scope.noticesForDisplay = []

            if ($scope.showType === "Search" || ($rootScope.can("SystemNoticeRead") && $scope.showType === "Manage")) {

                const displayNotices = []

                for (const notice of $scope.notices) {

                    if (($rootScope.can("SystemNoticeRead") && $scope.showType === "Manage") || notice.published) {
                        notice.showContent = false
                        notice.display_publish_on = moment(notice.publish_on).format("MMMM Do, YYYY")
                        displayNotices.push(notice)
                    }

                }

                $scope.noticesForDisplay = displayNotices

            } else {

                for (const notice of $scope.notices) {

                    if (notice.published) {
                        notice.showContent = false
                        notice.display_publish_on = moment(notice.publish_on).format("MMMM Do, YYYY")

                        if ($scope.showType === "Read") {
                            if (notice.read) {
                                $scope.noticesForDisplay.push(notice)
                            }
                            continue
                        }
                        if ($scope.showType === "Unread") {
                            if (!notice.read) {
                                $scope.noticesForDisplay.push(notice)
                            }
                            continue
                        }
                    }
                }
            }

            setTimeout(() => {

                $scope.$apply(() => {
                    for (const notice of $scope.noticesForDisplay) {
                        if (notice.content !== undefined) {

                            const content = noticeService.formatContentForDisplay(notice.content)
                            document.getElementById("noticeContent" + notice.id).innerHTML = $sce.trustAsHtml(content)

                        }
                    }
                })
            }, 5)
        }

        $scope.toggleNoticeContent = (noticeID) => {

            if ($scope.allowToggleContent) {

                for (const notice of $scope.notices) {

                    if (noticeID === notice.id) {
                        if (notice.showContent) {
                            // Toggle Closed
                            notice.showContent = false
                            return
                        } else if (notice.content !== undefined) {
                            // Toggle Open
                            notice.showContent = true
                            return
                        }
                    }
                }

                // Get Content + Toggle Open

                setTimeout(() => {

                    $scope.$apply(() => {

                        // Show "Loading ..."

                        const content = noticeService.formatContentForDisplay("Loading ...")
                        document.getElementById("noticeContent" + noticeID).innerHTML = $sce.trustAsHtml(content)

                        for (const notice of $scope.noticesForDisplay) {
                            if (notice.id === noticeID) {
                                notice.showContent = true
                                break
                            }
                        }
                    })
                }, 5)

                const startTime = new Date()

                const success = (data) => {

                    for (const notice of $scope.notices) {

                        if (noticeID === notice.id) {

                            notice.title              = data.title
                            notice.content            = data.content
                            notice.publish_on         = data.publish_on
                            notice.display_publish_on = moment(notice.publish_on).format("MMMM Do, YYYY")

                            const finishTime = new Date()

                            setTimeout(() => {

                                const content = noticeService.formatContentForDisplay(data.content)
                                document.getElementById("noticeContent" + noticeID).innerHTML = $sce.trustAsHtml(content)

                            }, Math.max(0, 400 - (finishTime - startTime)))

                            break

                        }
                    }
                }

                const failure = (error) => {
                    for (const notice of $scope.notices) {
                        if (noticeID = data.id) {
                            notice.content = error
                            break
                        }
                    }
                }

                noticeService.getNotice(noticeID, success, failure)

            }
        }

        $scope.markNotice = (noticeID, read) => {

            $scope.allowToggleContent = false

            const success = () => {

                $scope.allowToggleContent = true

                for (const notice of $scope.notices) {

                    if (noticeID === notice.id) {

                        notice.read = read
                        break

                    }
                }

                updateDisplayed()

            }

            const failure = () => {
                $scope.allowToggleContent = true
            }

            noticeService.markNotice(noticeID, read, success, failure)

        }

        $scope.show = function(type) {

            document.getElementById("searchField").value = ""
            const wasSearch = $scope.showType === "Search"

            $scope.showType = type

            if ($rootScope.can("SystemNoticeRead") && type === "Manage") {
                getNotices(true)
            } else if (wasSearch) {
                getNotices()
            } else {
                updateDisplayed()
            }
        }

        $scope.search = () => {

            const searchText = document.getElementById("searchField").value

            getNotices($rootScope.can("SystemNoticeRead") && $scope.showType === "Manage", searchText)

        }

        $scope.manageCreateNotice = () => {

            if ($rootScope.can("SystemNoticeCreate")) {

                $scope.allowToggleContent = false

                $uibModal.open({
                    templateUrl: "app/modals/notice-create-edit-modal.view.html",
                    controller:  "NoticeCreateEditModalController",
                    windowClass: "noticeModal",
                    backdrop:    "static",
                    keyword:     false,
                    resolve: {
                        existingNotice: () => {
                            return undefined
                        },
                        saveNotice: () => {
                            return (newNotice) => {
                                noticeService.createNotice(newNotice, (data) => {
                                    $scope.notices.unshift(data)
                                    updateDisplayed()
                                })
                            }
                        }
                    }
                }).result.catch(function(res) {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })

                setTimeout(() => {
                    $scope.allowToggleContent = true
                }, 25)

            }
        }

        $scope.manageEditNotice = (noticeID) => {

            if ($rootScope.can("SystemNoticeUpdate")) {

                $scope.allowToggleContent = false

                const success = (data) => {

                    $scope.allowToggleContent = true

                    $uibModal.open({
                        templateUrl: "app/modals/notice-create-edit-modal.view.html",
                        controller:  "NoticeCreateEditModalController",
                        backdrop:    "static",
                        keyword:     false,
                        windowClass: "noticeModal",
                        resolve: {
                            existingNotice: () => {
                                return data
                            },
                            saveNotice: () => {
                                return (updatedNotice) => {

                                    const success = (data) => {

                                        for (const notice of $scope.notices) {
                                            if (notice.id === data.id) {

                                                notice.title      = data.title
                                                notice.publish_on = data.publish_on
                                                notice.content    = data.content

                                                updateDisplayed()
                                                break

                                            }
                                        }
                                    }

                                    const failure = (error) => {
                                        console.error(error)
                                    }

                                    noticeService.updateNotice(updatedNotice, success, failure)

                                }
                            }
                        }
                    }).result.catch(function(res) {
                        if (!(res === "cancel" || res === "escape key press")) {
                            throw res
                        }
                    })
                }

                const failure = (error) => {
                    $scope.allowToggleContent = true
                    console.error(error)
                }

                noticeService.getNotice(noticeID, success, failure)

            }
        }

        $scope.manageDeleteNotice = (notice) => {

            $scope.allowToggleContent = false

            if ($rootScope.can("SystemNoticeDelete")) {

                $uibModal.open({
                    templateUrl: "app/modals/notice-delete-modal.view.html",
                    controller:  "NoticeDeleteModalController",
                    resolve: {
                        selectedNotice: () => {
                            return notice
                        },
                        deleteNotice: () => {
                            return (noticeID) => {

                                const success = () => {

                                    $scope.allowToggleContent = true

                                    for (let i = 0; i < $scope.notices.length; i++) {
                                        if ($scope.notices[i].id === noticeID) {

                                            $scope.notices.splice(i, 1)

                                            updateDisplayed()
                                            break

                                        }
                                    }
                                }

                                const failure = (error) => {
                                    $scope.allowToggleContent = true
                                    console.error(error)
                                }

                                noticeService.deleteNotice(noticeID, success, failure)
                            }
                        }
                    }
                }).result.catch(function(res) {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })

            } else {

                setTimeout(() => {
                    $scope.allowToggleContent = true
                }, 25)
            }
        }

        let initialDisplay = 2

        $scope.$watch("$root.displayNotice", () => {

            if (initialDisplay >= 0) {

                if (initialDisplay === 0) {
                    getNotices()
                }

                initialDisplay -= 1

            }
        })
    }
})()
